import { MobiDocument } from './MobiDocument';
import { Autorisations } from './Autorisations';

export class AutorisationsIndividu extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private individu_id: number;
    private autorisation_id: number;
    private affichageedition: number;


    public constructor(autorisationsIndividu: any) {
        super();
        this._id = autorisationsIndividu._id;
        this._rev = autorisationsIndividu._rev;
        this.id = autorisationsIndividu.id;
        this.individu_id = autorisationsIndividu.individu_id;
        this.autorisation_id = autorisationsIndividu.autorisation_id
        this.affichageedition = autorisationsIndividu.affichageedition
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getIndividu_id() {
        return this.individu_id;
    }

    public setIndividu_id(individu_id: number): void {
        this.individu_id = individu_id;
    }

    public getAutorisation_id() {
        return this.autorisation_id;
    }

    public setAutorisation_id(autorisation_id: number): void {
        this.autorisation_id = autorisation_id;
    }

    public getAutorisation() : Autorisations {
       return this.memdb.findOne({
            doctype: "AutorisationsDocument",
            fkey: "id",
            fvalue: this.autorisation_id
        })
    }

    public getAffichageedition(): number {
        return this.affichageedition;
    }

    public setAffichageedition(affichageedition: number): void {
        this.affichageedition = affichageedition;
    }
}